<template>
  <div class="sport_root_div">
    <div class="page-header header1">
      <div class="bluebar head_logo"></div>
      <div>
        {{ $t("message")["Sports.title"] }}&nbsp;&nbsp;&nbsp;&nbsp;{{
          data_date
        }}
      </div>
      <div style="margin-left: auto">
        <a-button style="margin-right: 15px" @click="exportToCSV">{{
          $t("message")["Export.button.name"]
        }}</a-button>
        <a-date-picker
          id="date_picker"
          @change="ChangeDataDate"
        ></a-date-picker>
      </div>
    </div>
    <div id="today_total_step_label">
      {{ this.total_steps }}
      <div class="unit_text">{{ $t("message")["Sports.step"] }}</div>
    </div>
    <div id="sport_chart" ref="sport_chart"></div>
    <div class="page-header">
      <div class="bluebar head_logo"></div>
      <div>{{ $t("message")["Sports.datalist"] }}</div>
    </div>
    <div id="sport_data_list">
      <a-table :columns="columns" :dataSource="listData" :rowKey="Start_time">
        <template slot="distance-column" slot-scope="Distance">
          <div class="table_text">
            {{ parseInt(Distance) }}{{ $t("message")["Sports.meter"] }}
          </div>
        </template>
        <template slot="duration-column" slot-scope="Duration">
          <div class="table_text">
            {{ Duration / 60 }}{{ $t("message")["Sports.minute"] }}
          </div>
        </template>
        <template slot="time-column" slot-scope="Start_time">
          <div class="table_text">{{ Start_time.substring(11) }}</div>
        </template>
        <template slot="type-column" slot-scope="Sport_type">
          <div class="table_img_div">
            <img
              class="table_img"
              v-if="Sport_type == 1"
              src="../../assets/walk.png"
            />
            <img
              class="table_img"
              v-else-if="Sport_type == 7"
              src="../../assets/run.png"
            />
            <img
              class="table_img"
              v-else-if="Sport_type == 147"
              src="../../assets/power_walk.png"
            />
            <img class="table_img" v-else src="../../assets/walk.png" />
          </div>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import echarts from "echarts";
import domain from "../../domain";
import request from "../../utils/request";
var chart;
export default {
data() {
    return {
        data_date:"",
        deviceid:"",
        device_type: 1,
        uid: "",
        total_steps: 0,
        hourlyData: [],
        listData: [],
        columns: [
            { title: this.$t("message")['Sports.step.title'], dataIndex: 'Step', scopedSlots: { customRender: "step-column" } },
            { title: this.$t("message")['Sports.distance.title'], dataIndex: 'Distance', scopedSlots: { customRender: "distance-column" } },
            { title: this.$t("message")['Sports.duration.title'], dataIndex: 'Duration', scopedSlots: { customRender: "duration-column" } },
            { title: this.$t("message")['Sports.startime.title'], dataIndex: 'Start_time', scopedSlots: { customRender: "time-column" } },
            { title: this.$t("message")['Sports.sportype.title'], dataIndex: 'Sport_type', scopedSlots: { customRender: "type-column" } },
        ]
    };
},
watch: {
    "$store.state.windowWidth": function() {
        var w;
        if (this.$store.state.fullscreen) {
            w = this.$store.state.windowWidth * 0.6 + "px";
        } else {
            w = this.$store.state.windowWidth * 0.7 + "px";
        }
        document.getElementById("sport_chart").style.width = w;
        chart.resize();
    }
},
methods: {
    exportToCSV(){
      const exStep =[]
      console.log(this.hourlyData)
      for(let i=0;i<this.hourlyData.length;i++){
        if(this.hourlyData[i]===0){
          continue
        }
        const oneData = {
          time: String(i).padStart(2,"0") +":00",
          steps: this.hourlyData[i]
        }
        exStep.push(oneData)
      }
      const msg = this.$t("message")
      const nickName = sessionStorage.getItem("nickname");
      let csvData = `${msg['Export.Base.title']}\n`; // 第一行
      csvData += `${msg['Export.Base.nickname']},${nickName},${msg['Export.Base.deviceId']},\'${this.deviceid},${msg['Export.Base.date']},${this.data_date}\n`  //第二行
      csvData += `\n${msg['Export.Base.details']}\n`  //第三行
      csvData += `${msg['Export.Base.times']},${msg['Export.Step.step']}\n`   //第四行
      exStep.forEach((item) => {
        csvData += `${item.time},${item.steps}\n`; // 数据行
      });

      //csv
      const csvFileName = `${nickName}_${this.deviceid}_Steps_${this.data_date}.csv`
      const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;'});
      // 创建一个指向Blob对象的URL
      const url = window.URL.createObjectURL(blob);
      // 创建一个隐藏的<a>元素并模拟点击以触发下载
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', csvFileName); // 设置下载文件名
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); // 清理
    },
    drawTimeBarChart() {
        var myChart2 = echarts.init(document.getElementById("sport_chart"));
        let option = this.getOption();
        myChart2.setOption(option);
        chart = myChart2;
    },

    reloadChartData() {
        let option = this.getOption();
        chart.setOption(option);
    },

    getOption() {
        var max_y = 40;
        var option = {
            title: {
            text: this.$t("message")["Sports.unit"]+":"+this.$t("message")["Sports.step"],
            textStyle: {
                color: "#999999",
                fontSize: "12"
            }
            },
            xAxis: {
            type: "category",
            data: [
                "00:00",
                "01:00",
                "02:00",
                "03:00",
                "04:00",
                "05:00",
                "06:00",
                "07:00",
                "08:00",
                "09:00",
                "10:00",
                "11:00",
                "12:00",
                "13:00",
                "14:00",
                "15:00",
                "16:00",
                "17:00",
                "18:00",
                "19:00",
                "20:00",
                "21:00",
                "22:00",
                "23:00"
            ],
            axisLabel: {
                show: true,
                fontSize: 12,
                color: "#999999",
                interval: function(index, name) {
                if (index % 6 == 0 || index == 23) return true;
                else return false;
                }
            }
            },
            yAxis: {
            type: "value",
            axisTick: {
                show: false
            },
            splitLine: {
                lineStyle: {
                type: "dashed"
                }
            },
            axisLabel: {
                fontSize: 12,
                color: "#999999",
                formatter: function(value) {
                if (value >= max_y) {
                    return value;
                } else return value;
                }
            }
            },
            series: [
            {
                data: this.hourlyData,
                type: "bar",
                barWidth: 8,
                itemStyle: { normal: { color: "#65A9FF" } }
            }
            ]
        };
        return option;
    },
    getSportsDataList(deviceid,data_date) {

        let mDate = new Date();
        let month = mDate.getMonth() + 1;
        let monthStr = month < 10 ? "0" + month : month;
        let day = mDate.getDate();
        let dayStr = day < 10 ? "0" + day : day;
        let currentdate =
        mDate.getFullYear() + "-" + monthStr + "-" + dayStr;
        let reqParams = {
            device_id: deviceid,
            record_date: data_date
        };
        let reqUrl = domain.URLS.sportHourlyDataUrl;
        if(this.device_type == 2){
            reqParams = {
                uid: this.uid,
                record_date: data_date
            };
            reqUrl = domain.URLS.sportBleHourlyDataUrl;
        }

        request({
            url: reqUrl,
            methods: "GET",
            params: reqParams
        })
        .then(
        res => {
            if (res.data.ReturnCode == 0) {
                var hoursData = [];
                let RData = res.data.Data;
                this.total_steps = RData.Step;
                hoursData[0] = RData.H0;
                hoursData[1] = RData.H1;
                hoursData[2] = RData.H2;
                hoursData[3] = RData.H3;
                hoursData[4] = RData.H4;
                hoursData[5] = RData.H5;
                hoursData[6] = RData.H6;
                hoursData[7] = RData.H7;
                hoursData[8] = RData.H8;
                hoursData[9] = RData.H9;
                hoursData[10] = RData.H10;
                hoursData[11] = RData.H11;
                hoursData[12] = RData.H12;
                hoursData[13] = RData.H13;
                hoursData[14] = RData.H14;
                hoursData[15] = RData.H15;
                hoursData[16] = RData.H16;
                hoursData[17] = RData.H17;
                hoursData[18] = RData.H18;
                hoursData[19] = RData.H19;
                hoursData[20] = RData.H20;
                hoursData[21] = RData.H21;
                hoursData[22] = RData.H22;
                hoursData[23] = RData.H23;
                this.hourlyData = hoursData;
                this.reloadChartData();
            } else{
                this.total_steps = 0;
                this.hourlyData.splice(0);
                this.reloadChartData();
            }
        },
        function() {}
        );

        reqParams = {
            device_id: deviceid,
            record_date: data_date
        };
        reqUrl = domain.URLS.sportDetailDataUrl;
        if(this.device_type == 2){
            reqParams = {
                uid: this.uid,
                record_date: data_date
            };
            reqUrl = domain.URLS.sportBleDetailDataUrl;
        }
        request({
            url: reqUrl,
            methods: "GET",
            params: reqParams
        })
        .then(
        res => {
            if (res.data.ReturnCode == 0) {
                let RData = res.data.Data;
                this.listData = RData;
                console.log('this.listData:',this.listData);
            } else {
                this.listData.splice(0);
            }
        },
        function() {}
        );
    },
    handleMouseWheel(event) {

      // Check if the middle mouse button is clicked (event.button === 1)

        // Calculate the zoom factor based on the mouse wheel delta
        const offset = event.deltaY * 0.1; // You can adjust the zoom speed
        // Get the current zoom option from the chart
        const currentZoomStart = 0 + offset;
        const currentZoomEnd = 100 + offset;


        // Set the new zoom option for the chart
        chart.dispatchAction({
          type: 'dataZoom',
          start: currentZoomStart,
          end: currentZoomEnd,
        });

        // Prevent the default behavior (scrolling the page)
        event.preventDefault();
    },

    ChangeDataDate(val){
        let date_str = val.format('YYYY-MM-DD');
        this.data_date = date_str;
        this.getSportsDataList(this.deviceid,this.data_date);
    }
},
mounted: function() {
    this.device_type = sessionStorage.getItem("device_type");
    this.deviceid = sessionStorage.getItem("deviceid");
    if(this.device_type==2){
        this.uid = sessionStorage.getItem("uid");
    }
    this.data_date = this.$route.params.data_date;
    this.drawTimeBarChart();
    this.getSportsDataList(this.deviceid,this.data_date);
    //this.$refs.time_chart.addEventListener('mousewheel', this.handleMouseWheel);
},
beforeDestroy() {
    // Remember to remove the event listener to prevent memory leaks
    //this.$refs.time_chart.removeEventListener('mousewheel', this.handleMouseWheel);
    chart.dispose();
}
};
</script>

<style scoped lang="scss">
.sport_root_div {
    padding-bottom: 10px;
    position: relative;
    left: 0px;
    border: 1px solid white;
}

.page-header {
    height: 50px;
    font-size: 16px;
    color: #292929;
    letter-spacing: 0;
    line-height: 30px;
    font-weight: bold;
    padding-left: 15px;
    padding-right: 15px;
    display: flex;
    align-items: center;
}

.header1 {
    justify-content: space-around;
}


.bluebar {
    width: 4px;
    height: 13px;
    background-color: #2284FF;
}

.head_logo {
    margin-right: 10px;
}

#sport_data_list {
    height: 200px;
    margin-top: 10px;
}

#sport_chart {
    margin-top:30px;
    height: 300px;
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
}

#data-head-logo {
    margin-top: 15px;
    margin-right: 10px;
    margin-left: 30px;
    float: left;
    width: 20px;
    height: 20px;
    line-height: 50px;
}

#page-title {
    float: left;
    font-family: PingFang-SC-Semibold;
    font-size: 16px;
    color: #52ba9f;
    letter-spacing: 0;
    text-align: left;
    line-height: 16px;
    line-height: 50px;
}

#today_total_step_label {
    font-weight: bold;
    font-size: 16px;
    color: #292929;
    display: flex;
    align-items: center;
    margin-left: 12px;
}

.unit_text{
    font-size: 12px;
    color: #727272;
}

#date_picker {
    margin-left: auto;
}

.table_text {
    color: #5C5C5C;
    font-szie: 14px;
}

.table_img_div {
    height: 36px;
    width: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.table_img {
    height: 32px;
    width: 32px;    
}
</style>
